import { Rules, methods } from 'sigma-mappings';
import NotImplemented from '@/components/NotImplemented';
import DuvalTriangle1 from './duval/Triangle1';
import DuvalTriangle4 from './duval/Triangle4';
import DuvalTriangle5 from './duval/Triangle5';
import Triangle1Footer from './duval/Triangle1Footer';
import Triangle4Footer from './duval/Triangle4Footer';
import Triangle5Footer from './duval/Triangle5Footer';
import BaseGasRatioContent from './baseGasRatio/Content';
import BaseGasRatioFooter from './baseGasRatio/Footer';

/**
 * Definição de components de conteúdo para os cards.
 *
 * Cada método tem a sua definição de components.
 *
 * Interface:
 * {
 *   content: OBRIGATÓRIO, é o conteúdo principal do card.
 *   size: Optional, tamanho do card. Valores: normal | large. Padrão normal.
 *   header: Opcional, se omitido mostra o título normal do método.
 *   footer: Opcional, se omitido não incluí nenhum rodapé.
 *   notExecuted: Opcional, se omitido usa-se o card padrão de método não executado. É recomendável
 *     usar o card padrão. Exceto se houver exceção para um caso específico, todos os metodos usam
 *     o mesmo padrão de card para caso de não executado.
 * }
 *
 * Todos os components receberão a prop "data", sem tipo específico, com os dados retornados do
 * back-end. Cada card tratará "data" de maneira individual conforme sua regra.
 */
export default {
  [Rules.IEC_60599]: {
    [methods[Rules.IEC_60599].GASES_RATIO_2015]: {
      content: BaseGasRatioContent,
      footer: BaseGasRatioFooter,
    },
  },
  [Rules.IEEE_C57_104]: {
    [methods[Rules.IEEE_C57_104].DOERNENBURG]: {
      content: BaseGasRatioContent,
      footer: BaseGasRatioFooter,
    },
    [methods[Rules.IEEE_C57_104].ROGERS]: {
      content: BaseGasRatioContent,
      footer: BaseGasRatioFooter,
    },
    [methods[Rules.IEEE_C57_104].CLASSIFICATION_IN_CONDITIONS]: {
      size: 'large',
      content: NotImplemented,
    },
  },
  [Rules.NBR_7274]: {
    [methods[Rules.NBR_7274].GASES_RATIO_2012]: {
      content: BaseGasRatioContent,
      footer: BaseGasRatioFooter,
    },
  },
  [Rules.DUVAL]: {
    [methods[Rules.DUVAL].TRIANGLE_1]: {
      content: DuvalTriangle1,
      footer: Triangle1Footer,
    },
    [methods[Rules.DUVAL].TRIANGLE_4]: {
      content: DuvalTriangle4,
      footer: Triangle4Footer,
    },
    [methods[Rules.DUVAL].TRIANGLE_5]: {
      content: DuvalTriangle5,
      footer: Triangle5Footer,
    },
  },
};
